(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rn-header"]) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.rn-hdr .mnav[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary')?.focus();
  event.preventDefault();
});

  } catch(e) { console.error(e); }
})();
})();
